import { render } from "./BusinessPage.vue?vue&type=template&id=2196f821"
import script from "./BusinessPage.vue?vue&type=script&lang=js"
export * from "./BusinessPage.vue?vue&type=script&lang=js"

import "./BusinessPage.vue?vue&type=style&index=0&id=2196f821&lang=css"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__